package com.nonopn.skydome.common.app.pages.main.model.api

import androidx.compose.ui.graphics.Color
import com.nonopn.skywatcher.design.theme.AppColor

enum class ActivityAge(val color: Color) {
    Recent(AppColor.RedDarker),
    Moderate(AppColor.RedDark),
    Old(AppColor.Red),
    VeryOld(AppColor.Orange)
}
